var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isInit
    ? _c(
        "el-form",
        {
          ref: "form",
          staticClass: "color-picker",
          attrs: {
            model: _vm.field,
            "label-width": _vm.field.name ? "120px" : "0"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "input-row",
              attrs: { prop: "def_val", rules: _vm.fieldRules }
            },
            [
              _vm.field.name
                ? _c(
                    "div",
                    {
                      staticClass: "label-item common",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [
                      _c("p", { staticClass: "label-text" }, [
                        _vm._v(_vm._s(_vm.field.desc))
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "light", placement: "bottom-start" }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v("\n                    - name: "),
                              _c("strong", [_vm._v(_vm._s(_vm.field.name))]),
                              _c("br")
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", { staticClass: "label-icon el-icon-info" })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-color-picker", {
                on: { change: _vm.valChangeHandler },
                model: {
                  value: _vm.field.def_val,
                  callback: function($$v) {
                    _vm.$set(_vm.field, "def_val", $$v)
                  },
                  expression: "field.def_val"
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4334ad22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4334ad22","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compEditForm/colorPicker.vue
// module id = 1217
// module chunks = 7